class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.closeDelayMilliseconds = this.dataset.closeDelayMilliseconds;
        this.openDelayMilliseconds = this.dataset.openDelayMilliseconds;
        this.mainDetailsToggle = this.querySelector('details');
        this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
        this.mainContent = document.getElementById('MainContent');

        this.hoverOpenTimer = null;
        this.hoverCloseTimer = null;

        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut);
        this.mainDetailsToggle.addEventListener('toggle', this.onToggle);
        this.mainDetailsToggle.addEventListener('mouseover', this.onMouseOver);
        this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave);
    }

    onMouseOver = () => {
        this.clearHoverTimers();

        this.hoverOpenTimer = setTimeout(() => {
            if (this.mainDetailsToggle.matches(':hover')) {
                this.mainDetailsToggle.open = true;
                this.mainContent.inert = true;
            }
        }, this.openDelayMilliseconds);
    };

    onMouseLeave = () => {
        this.clearHoverTimers();

        this.hoverCloseTimer = setTimeout(() => {
            if (!this.mainDetailsToggle.matches(':hover')) {
                this.mainDetailsToggle.open = false;
                this.mainContent.inert = false;
            }
        }, this.closeDelayMilliseconds);
    };

    clearHoverTimers() {
        if (this.hoverOpenTimer) {
            clearTimeout(this.hoverOpenTimer);
            this.hoverOpenTimer = null;
        }
        if (this.hoverCloseTimer) {
            clearTimeout(this.hoverCloseTimer);
            this.hoverCloseTimer = null;
        }
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        });
    }

    onToggle() {
        if (!this.animations) this.animations = this.content.getAnimations();

        if (this.mainDetailsToggle.hasAttribute('open')) {
            this.animations.forEach((animation) => animation.play());
        } else {
            this.animations.forEach((animation) => animation.cancel());
        }
    }

    close() {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
    constructor() {
        super();
        this.header = document.querySelector('.header-wrapper');
    }

    onToggle() {
        if (!this.header) return;
        this.header.preventHide = this.mainDetailsToggle.open;

        if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
        document.documentElement.style.setProperty(
            '--header-bottom-position-desktop',
            `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
        );
    }
}

customElements.define('header-menu', HeaderMenu);
